import React from "react";
import { getAllAppointments, deleteAppointments } from "../api";
import { Link, NavLink } from "react-router-dom";

import { toast } from "react-toastify";

import "./Appointments.css";

class Appointments extends React.Component {
  state = {
    appointments: [],
  };

  async componentDidMount() {
    const response = await getAllAppointments();
    this.setState({
      appointments: response.data,
    });
  }

  handleDeleteAppointment = async (id) => {
    await deleteAppointments(id);
    toast.dark(`Your appointment has been cancelled!`);
    const response = await getAllAppointments();
    this.setState({
      appointments: response.data,
    });
  };

  render() {
    return (
     <main class="box">
      <div className="marginTotal">
        <div className="backMenuBox">
          <NavLink to="/map">
            <img src="/images/back.png" />
          </NavLink>
          <h1>Your Appointments</h1>
        </div>

        <div className="totalAppointments">
          {this.state.appointments.map((appointment, index) => {
            return (
              <section key={index} className="appointmentsBox">
                <div className="appointmentsInfoBox">
                <div className="appointmentsBarBox" />
                  
                  <div className="appointmentsTextBox">
                  <div>
                    <h2>{appointment.name}</h2>
                    <p>{appointment.icon}</p>
                  </div>
                  <Link
                    to={{
                      pathname: "/addreview",
                      place: {
                        name: appointment.name,
                        icon: appointment.icon,
                        date: appointment.date,
                        hour: appointment.hour,
                      },
                    }}
                  >
                    <button>Add Review</button>
                  </Link>
                </div>

                </div>

                <div className="dateBox">
                  <div className="dateBoxButtonBox">
                    <button
                      onClick={() =>
                        this.handleDeleteAppointment(appointment._id)
                      }
                    >
                      <img src="/images/del.png" />
                    </button>
                  </div>
                  <div className="dateBoxTextBox">
                    <p className="dateBoxTextBoxFix">{new Date(appointment.date).toDateString()}</p>
                    <p className="dateHourBox">{appointment.hour}</p>
                  </div>
                </div>
              </section>
            );
          })}
        </div>
      </div>
      </main>
    );
  }
}

export default Appointments;
